import type { Country } from '../types/types';

export const countryList: Country[] = [
  { isoCode: 'DE', countryName: 'Germany' },
  { isoCode: 'US', countryName: 'United States' },
  { isoCode: 'FR', countryName: 'France' },
  { isoCode: 'IT', countryName: 'Italy' },
  { isoCode: 'ES', countryName: 'Spain' },
  { isoCode: 'CN', countryName: 'China' },
  { isoCode: 'JP', countryName: 'Japan' },
  { isoCode: 'IN', countryName: 'India' },
  { isoCode: 'BR', countryName: 'Brazil' },
  { isoCode: 'GB', countryName: 'United Kingdom' },
  { isoCode: 'FI', countryName: 'Finland' },
  { isoCode: 'SE', countryName: 'Sweden' },
  { isoCode: 'NO', countryName: 'Norway' },
  { isoCode: 'NL', countryName: 'Netherlands' },
  { isoCode: 'BE', countryName: 'Belgium' },
  { isoCode: 'CH', countryName: 'Switzerland' },
  { isoCode: 'AT', countryName: 'Austria' },
  { isoCode: 'PL', countryName: 'Poland' },
  { isoCode: 'CZ', countryName: 'Czech Republic' },
  { isoCode: 'PT', countryName: 'Portugal' },
  { isoCode: 'GR', countryName: 'Greece' },
  { isoCode: 'HU', countryName: 'Hungary' },
  { isoCode: 'RO', countryName: 'Romania' },
  { isoCode: 'SK', countryName: 'Slovakia' },
  { isoCode: 'SI', countryName: 'Slovenia' },
  { isoCode: 'IE', countryName: 'Ireland' },
  { isoCode: 'LU', countryName: 'Luxembourg' },
  { isoCode: 'HR', countryName: 'Croatia' },
  { isoCode: 'BG', countryName: 'Bulgaria' },
  { isoCode: 'LT', countryName: 'Lithuania' },
  { isoCode: 'LV', countryName: 'Latvia' },
  { isoCode: 'EE', countryName: 'Estonia' },
  { isoCode: 'CY', countryName: 'Cyprus' },
  { isoCode: 'MT', countryName: 'Malta' },
  { isoCode: 'DK', countryName: 'Denmark' },
  { isoCode: 'IS', countryName: 'Iceland' },
  { isoCode: 'CA', countryName: 'Canada' },
  { isoCode: 'MX', countryName: 'Mexico' },
  { isoCode: 'AR', countryName: 'Argentina' },
  { isoCode: 'CL', countryName: 'Chile' },
  { isoCode: 'CO', countryName: 'Colombia' },
  // … extend to full list later
];
